<div class="d-flex flex-column">
  <h1 class="mb-4">Torneos</h1>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <a mat-raised-button color="primary" (click)="createNewTournament()"
      >NUEVO TORNEO</a
    >
    <div class="d-flex align-items-center">
      <span class="mr-3 ">Estado: </span>
      <mat-form-field>
        <mat-select
          [(value)]="selectedState"
          (selectionChange)="loadTournaments()"
        >
          <mat-option *ngFor="let state of states" [value]="state">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <table mat-table [dataSource]="tournamentsListData">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let el">{{ el.name }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let el">{{ getTournamentStatus(el.state) }}</td>
    </ng-container>
    <ng-container matColumnDef="teamQuantity">
      <th mat-header-cell *matHeaderCellDef>Cant. Equipos</th>
      <td mat-cell *matCellDef="let el">{{ el.teams_quantity }}</td>
    </ng-container>
    <ng-container matColumnDef="matchQuantity">
      <th mat-header-cell *matHeaderCellDef>Cant. Partidos</th>
      <td mat-cell *matCellDef="let el">{{ el.team_player_quantity }}</td>
    </ng-container>
    <ng-container matColumnDef="dateFrom">
      <th mat-header-cell *matHeaderCellDef>Desde</th>
      <td mat-cell *matCellDef="let el">
        {{ formatStartDate(el.start_date) }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="goToTournamentDetail(row.id)"
      class="link-table"
    ></tr>
  </table>

  <mat-paginator
    [length]="totalRecords"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
